import auth from "./auth";
import content from "./content";
import user from "./user";
import provider from "./provider";
import engagement from "./engagement";
import outcome from "./outcome";
import ws from "./ws";
import overview from "./overview";

export default {
  auth,
  content,
  user,
  provider,
  engagement,
  ws,
  outcome,
  overview,
};
